import { SlideUpLine, FadeUp, Stagger, StaggerItem } from "@/pages/_shared/anim";
import SandblastCanvas from "./SandblastCanvas";
import { useEffect, useState } from "react";
import Elevator from "../../../assets/Home1.jpg"
import { Link } from "react-router-dom";

const capabilities = [
  { label: "ALL-BRAND", sub: "Spare Parts Support" },
  { label: "END-TO-END", sub: "Elevator Solutions" },
  { label: "MULTI-LAYER", sub: "PCB Repair Capability" },
  { label: "VERTICAL + INCLINED", sub: "Transport Support" },
];

export default function Hero() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section
      id="top"
      className="relative min-h-screen flex flex-col"
      style={{ backgroundColor: "#0F1B2E" }}
    >
      <SandblastCanvas />

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40 pointer-events-none" />

      <div
        className={`relative z-10 flex-1 min-h-0 px-6 md:px-12 pt-32 md:pt-26 pb-6 pointer-events-none transition-all duration-[1200ms] ease-out ${
          mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="h-full grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          <div className="lg:col-span-7 flex flex-col justify-between min-h-0">
            <div className="flex items-center gap-3 text-white/55 text-[11px] md:text-xs tracking-[0.22em] uppercase font-mono mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-crest-orange animate-pulse"></span>
              <span>ELEVATOR SOLUTIONS · TECHNICAL SUPPORT · ALL-BRAND SPARE PARTS</span>
            </div>

            <h1
              className="font-display text-crest-orange text-5xl md:text-6xl lg:text-7xl xl:text-[88px] leading-[0.95] tracking-tight font-extrabold"
              style={{ textShadow: "0 0 40px rgba(0,0,0,0.55)" }}
            >
              <SlideUpLine as="div" delay={0.1}>From a Single</SlideUpLine>
              <SlideUpLine as="div" delay={0.25}>Spare Part to a</SlideUpLine>
              <SlideUpLine as="div" delay={0.4}>Complete Elevator Solution.</SlideUpLine>
            </h1>

            <FadeUp delay={0.5}>
              <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xl mt-4 pointer-events-auto">
                Uplift One delivers comprehensive elevator and escalator solutions — from supply and installation to technical support, maintenance, modernization, PCB repair, testing, programming, safety inspections, and all-brand spare parts.
              </p>
            </FadeUp>

            <div className="min-h-[12px]" />

            <div className="space-y-5">
              <FadeUp delay={0.55} className="pointer-events-auto">
                <div className="flex flex-wrap gap-3">
                  <Link
                    to="/solutions"
                    className="inline-flex items-center gap-2 bg-crest-orange text-crest-deep hover:bg-crest-orangeLight transition-colors px-7 py-3.5 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
                  >
                    EXPLORE OUR SOLUTIONS
                    <i className="ri-arrow-right-up-line"></i>
                  </Link>
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 border border-white text-white hover:bg-crest-orange hover:border-crest-orange hover:text-crest-deep transition-colors px-7 py-3.5 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
                  >
                    GET TECHNICAL SUPPORT
                    <i className="ri-arrow-right-up-line"></i>
                  </Link>
                </div>
              </FadeUp>

              <Stagger
                stagger={0.07}
                delay={0.6}
                className="grid grid-cols-2 xl:grid-cols-4 gap-3 pointer-events-auto"
              >
                {capabilities.map((c) => (
                  <StaggerItem
                    key={c.label}
                    className="bg-crest-orange/95 backdrop-blur-sm rounded-md px-4 py-3.5 flex flex-col"
                  >
                    <div className="font-display text-xl md:text-2xl font-medium text-crest-deep leading-tight">
                      {c.label}
                    </div>
                    <div className="text-crest-deep/80 text-[11px] md:text-xs font-medium leading-tight mt-1">
                      {c.sub}
                    </div>
                  </StaggerItem>
                ))}
              </Stagger>
            </div>
          </div>

          <FadeUp
            delay={0.35}
            className="lg:col-span-5 relative pointer-events-auto min-h-[320px] lg:min-h-0"
          >
            <div className="relative w-full h-full rounded-xl overflow-hidden border border-crest-orange/25 bg-black/40">
              <img
                src={Elevator}
                title="Elevator technical solutions and PCB repair"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
            </div>
          </FadeUp>
        </div>
      </div>

      <div className="relative z-10 border-t border-white/10 bg-[#0A1522] overflow-hidden shrink-0">
        <div className="flex animate-marquee whitespace-nowrap py-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex items-center gap-8 px-8 shrink-0">
              <span className="text-white text-base md:text-lg font-display">
                Complete elevator and escalator solutions since 2020
              </span>
              <span className="w-6 h-6 flex items-center justify-center text-crest-orange">
                <i className="ri-arrow-up-line text-lg"></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}